import { TOPUP_CONFIG_COMMON } from '@/common/const/topup.const'

export const TOPUP_CONFIG = Object.assign({}, TOPUP_CONFIG_COMMON, {
  topupAmounts: [10, 30, 35, 45, 50],
  topupAmountRecommend: 45,
  topupAmountDefault: 45,
  hasMarketingAgree: true,
  hasReminderEnabled: true,
  hasLoginEnabled: true,
  useWhiteLabelPaywall: false
})
